export default __webpack_public_path__ + "static/BLUE_GLOW_BG-eefb4a6ce6c5ad06413a2d6ae7ca5433.png";